import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Jobtype } from '../models/jobtype.model';
import { AppConfig } from '../helpers/app.config';

@Injectable({
  providedIn: 'root'
})
export class JobtypeService {

  constructor(private httpClient: HttpClient) { }

  index(companyTypeId, clientId): Observable<Jobtype[]> {
    return this.httpClient.get<Jobtype[]>(AppConfig.settings.API + '/jobtypes', { params: { companyTypeId, clientId } as any });
  }
}
